<template>
  <button
    v-quick-title="disabled ? '' : title"
    class="text-field-menu-item"
    :class="elClasses"
    :title="title"
    @click="action"
    @mousedown="onMouseDown"
  >

    <Icon
      class="text-field-menu-item__icon"
      :class="`text-field-menu-item__icon--${icon}`"
    >
      {{ icons[icon] }}
    </Icon>
  </button>
</template>

<script>
/**
 * Item in the menu bar of a TipTap text field.
 * Taken from https://www.tiptap.dev/examples/collaborative-editing
 * @vue-prop {String} icon - Icon used for the item
 * @vue-prop {String} title - Title of the menu item
 * @vue-prop {Function} action - Function to trigger onclick
 * @vue-prop {Function} isActive - Function used to check if a menu item is in active state
 */


import {
  mdiFormatBold,
  mdiFormatItalic,
  mdiFormatUnderline,
  mdiFormatStrikethroughVariant,
  mdiFormatColorHighlight,
  mdiFormatListBulleted,
  mdiFormatListNumbered,
  mdiFormatListChecks,
  mdiArrowULeftTop,
  mdiArrowURightTop,
} from '@mdi/js';
// Components
import Icon from '@/components/icon.vue';

export default {

  name: 'TextFieldMenuItem',

  components: {
    Icon,
  },

  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    action: {
      type: Function,
      required: true,
    },
    isActive: {
      type: Function,
      default: null,
    },
    disabled: Boolean,
  },

  data() {
    return {
      icons: {
        bold: mdiFormatBold,
        italic: mdiFormatItalic,
        underline: mdiFormatUnderline,
        strikethrough: mdiFormatStrikethroughVariant,
        highlight: mdiFormatColorHighlight,
        unorderedList: mdiFormatListBulleted,
        numberedList: mdiFormatListNumbered,
        checkList: mdiFormatListChecks,
        undo: mdiArrowULeftTop,
        redo: mdiArrowURightTop,
      },
    };
  },

  computed: {
    elClasses() {
      return {
        'text-field-menu-item--disabled': this.disabled,
        'is-active': this.isActive ? this.isActive() : undefined,
      };
    },
  },

  methods: {
    onMouseDown() {
      this.$emit('mousedown');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.text-field-menu-item {
  width: 1.75rem;
  height: 1.75rem;
  color: $color-main-text-dark;
  border: none;
  background-color: transparent;
  border-radius: 0.4rem;
  padding: 0.25rem;
  margin-right: 0.1rem;

  &__icon {
    width: 1.4rem;
    height: 1.4rem;

    &--strikethrough {
      box-sizing: border-box;
      width: 1.25rem;
      height: 1.25rem;
    }
  }

  &.is-active,
  &:not(.text-field-menu-item--disabled):hover {
    background-color: #ddd;
  }
}
</style>
